import React, { useContext } from "react";
import { Route as RouterRoute, Redirect, matchPath, useLocation } from "react-router-dom";
import moment from "moment";
import { Box, Typography } from "@material-ui/core";

import { AuthContext } from "../context/Auth/AuthContext";
import BackdropLoading from "../components/BackdropLoading";

const Route = ({ component: Component, isPrivate = false, ...rest }) => {
	const { isAuth, loading, user } = useContext(AuthContext);
	const actualLocation = useLocation();
	// Some routes are nested in the layout rather than a Switch. Unmatched routes must not redirect.
	if (rest.path && !matchPath(actualLocation.pathname, { path: rest.path, exact: rest.exact, strict: rest.strict })) return null;
	const managerReportRoute = rest.path === "/dashboard";
	const managerAllowedRoute = rest.path === "/management" || managerReportRoute;

	// Verificar se a empresa está vencida
	const isCompanyExpired = () => {
		if (!user || !user.company || user.company.id === 1) {
			return false; // Empresa ID 1 nunca expira
		}

		const dueDate = user.company.dueDate;
		if (!dueDate) return false;

		// Comparar apenas as datas (sem horas) para permitir acesso até 23h59 do dia do vencimento
		const hojeInicio = moment().startOf('day');
		const vencimentoInicio = moment(dueDate).startOf('day');
		
		// Empresa está vencida apenas após o dia do vencimento
		return hojeInicio.isAfter(vencimentoInicio, 'day');
	};

	if (!isAuth && isPrivate) {
		return (
			<>
				{loading && <BackdropLoading />}
				<Redirect to={{ pathname: "/login", state: { from: rest.location } }} />
			</>
		);
	}

	if (isAuth && !isPrivate) {
		return (
			<>
				{loading && <BackdropLoading />}
				<Redirect to={{ pathname: "/", state: { from: rest.location } }} />;
			</>
		);
	}

	// Expired managers have no access to the finance workflow. Keep them on a
	// simple notice instead of redirecting between management and finance routes.
	if (isAuth && isPrivate && user?.profile === "manager" && isCompanyExpired()) {
		return (
			<Box p={4}>
				<Typography variant="h6">Acesso temporariamente indisponível</Typography>
				<Typography color="textSecondary">
					A empresa está com o acesso vencido. Procure o administrador da sua empresa.
				</Typography>
			</Box>
		);
	}

	if (isAuth && isPrivate && user?.profile === "manager" && !managerAllowedRoute) {
		return <Redirect to={{ pathname: "/management" }} />;
	}

	// Se está autenticado e a empresa está vencida
	if (isAuth && isPrivate && isCompanyExpired()) {
		// Permite acesso apenas ao /financeiro-aberto
		if (rest.path !== "/financeiro-aberto") {
			return (
				<>
					{loading && <BackdropLoading />}
					<Redirect to={{ pathname: "/financeiro-aberto", state: { from: rest.location } }} />
				</>
			);
		}
	}

	return (
		<>
			{loading && <BackdropLoading />}
			<RouterRoute {...rest} component={Component} />
		</>
	);
};

export default Route;
